function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Fragment } from "react";
import CarinaTextbox from "../../../Textbox/Textbox";
import FormElement from "../../../FormElement/FormElement";
import { ReadOnlyText } from "../../ReadOnlyText/ReadOnlyText";
import { FieldMessages } from "../../FieldMessages/FieldMessages";
import { useField } from "../../hooks/useField/index";
import { resolveIds } from "../../../../utils/resolveIds";
import Label from "../../../Label";
export function Textbox(_param) {
    var dependencies = _param.dependencies, label = _param.label, messages = _param.messages, name = _param.name, readOnly = _param.readOnly, readOnlyRenderer = _param.readOnlyRenderer, validate = _param.validate, hasError = _param.hasError, hideLabel = _param.hideLabel, _id = _param.id, id = _id === void 0 ? name : _id, isRequired = _param.isRequired, labelRequiredTitle = _param.labelRequiredTitle, onBlur = _param.onBlur, onChangeText = _param.onChangeText, onUpdateTransform = _param.onUpdateTransform, required = _param.required, testID = _param.testID, propDrop = _objectWithoutProperties(_param, [
        "dependencies",
        "label",
        "messages",
        "name",
        "readOnly",
        "readOnlyRenderer",
        "validate",
        "hasError",
        "hideLabel",
        "id",
        "isRequired",
        "labelRequiredTitle",
        "onBlur",
        "onChangeText",
        "onUpdateTransform",
        "required",
        "testID"
    ]);
    var ref = useField({
        name: name,
        dependencies: dependencies,
        onBlur: onBlur,
        onUpdate: onChangeText,
        onUpdateTransform: onUpdateTransform,
        readOnly: readOnly,
        required: isRequired !== null && isRequired !== void 0 ? isRequired : required,
        validate: validate
    }), fieldValue = ref.fieldValue, fieldErrors = ref.fieldErrors, dependencyValues = ref.dependencyValues, readOnlyField = ref.readOnlyField, showRequired = ref.showRequired, handleBlur = ref.handleBlur, handleUpdate = ref.handleUpdate, isRtl = ref.formContext.isRtl;
    return _jsxs(FormElement, {
        isRtl: isRtl,
        children: [
            readOnlyField ? _jsxs(Fragment, {
                children: [
                    _jsx(Label, _objectSpread({}, resolveIds(id, testID, 'label', true), {
                        htmlFor: id,
                        isHidden: hideLabel,
                        isRequired: showRequired,
                        isRtl: isRtl,
                        requiredTitle: labelRequiredTitle,
                        children: label
                    })),
                    _jsx(ReadOnlyText, _objectSpread({}, resolveIds(id, testID), {
                        readOnlyRenderer: readOnlyRenderer,
                        children: fieldValue
                    }))
                ]
            }) : _jsx(CarinaTextbox, _objectSpread({}, propDrop, resolveIds(id, testID, undefined, true), {
                hasError: !!fieldErrors || hasError,
                hideLabel: hideLabel,
                isRequired: showRequired,
                isRtl: isRtl,
                labelRequiredTitle: labelRequiredTitle,
                labelText: label,
                onBlur: handleBlur,
                onChangeText: handleUpdate,
                value: fieldValue
            })),
            _jsx(FieldMessages, _objectSpread({}, resolveIds(id, testID, 'messages', true), {
                messages: messages,
                fieldErrors: fieldErrors,
                readOnlyField: readOnlyField,
                fieldTools: {
                    fieldValue: fieldValue,
                    dependencyValues: dependencyValues,
                    showRequired: showRequired
                },
                isRtl: isRtl
            }))
        ]
    });
}
